"use client";

import { useAuth } from "@/contexts/AuthContext";
import AuthModal from "./AuthModal";
import UserMenu from "./UserMenu";

export default function UserMenuIcon({
  theme,
}: {
  theme: "transparent" | "light";
}) {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <UserMenu theme={theme} />
  ) : (
    <AuthModal theme={theme} />
  );
}
